// extracted by mini-css-extract-plugin
export default {"title":"RegistrationSection_title__vy2ws","regnInfoText":"RegistrationSection_regnInfoText__gKN9a","jumbo":"RegistrationSection_jumbo__2gVKz"};